/**
 * Clears body scroll locks that were applied without an open modal/drawer.
 * Some apps lock overflow ~1–2s after load and never release it.
 */
(function () {
  const OPEN_UI_SELECTOR = [
    'modal-dialog[open]',
    'cart-drawer.active',
    'details-modal details[open]',
    'header-drawer details[open].menu-opening',
    'menu-drawer details[open].menu-opening',
    'pickup-availability-drawer[open]',
    '.product-popup-modal[open]',
    'details.menu-opening[open]',
  ].join(', ');

  function hasLegitimateLock() {
    return Boolean(document.querySelector(OPEN_UI_SELECTOR));
  }

  function clearUnexpectedLock() {
    if (hasLegitimateLock()) return;

    const body = document.body;
    const html = document.documentElement;
    const lockedByClass = /\boverflow-hidden(-mobile|-tablet|-desktop)?\b/.test(body.className);
    const lockedByStyle =
      body.style.overflow === 'hidden' ||
      body.style.position === 'fixed' ||
      html.style.overflow === 'hidden';

    if (!lockedByClass && !lockedByStyle) return;

    const pinnedTop = body.style.top;
    body.classList.remove(
      'overflow-hidden',
      'overflow-hidden-mobile',
      'overflow-hidden-tablet',
      'overflow-hidden-desktop'
    );
    body.style.overflow = '';
    body.style.position = '';
    body.style.top = '';
    body.style.width = '';
    html.style.overflow = '';

    if (pinnedTop) {
      const y = Math.abs(parseInt(pinnedTop, 10)) || 0;
      window.scrollTo(0, y);
    }
  }

  const start = () => {
    clearUnexpectedLock();
    new MutationObserver(clearUnexpectedLock).observe(document.body, {
      attributes: true,
      attributeFilter: ['class', 'style'],
    });
    setInterval(clearUnexpectedLock, 750);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
